import DiamondIQ from './DiamondIQ_V2';
export default function App() {
  return <DiamondIQ />;
}
